import LocationMarker from 'icons/LocationMarker';
import LogoHeader from '../LogoHeader';
import NavBar from '../NavBar';
import NavButton from '../NavButton';
import compact from 'helpers/compact';
import ScreenSizes, { ScreenSize } from '../ScreenSizes';
import AdminBar from 'components/AdminBar';
import TextLink from '../TextLink';

export default function SchoolSubNav({
  school
}: {
  school: {
    id: string;
    image?: string;
    name: string;
    locationText: string;
    mascot?: string;
    webPath: string;
    webTeamsPath?: string;
    webScoresPath?: string;
    webNewsPath?: string;
    webPhotosPath?: string;
    nfhsNetworkUrl?: string;
    gofanTicketingUrl?: string;
    owner?: {
      id: string;
      username: string;
    };
  };
}) {
  return (
    <>
      <LogoHeader
        alt={[school.name, school.mascot].filter(compact).join(' ')}
        image={school.image}
        title={
          <>
            {school.name}
            {school.mascot && <ScreenSizes hide={ScreenSize.SMALL}> {school.mascot}</ScreenSizes>}
          </>
        }
        subTitle="School Hub"
        subText={
          <>
            <LocationMarker width={8} height={11} /> {school.locationText}
          </>
        }
      />
      <NavBar>
        <NavButton href={school.webPath}>Home</NavButton>
        {school.webTeamsPath && <NavButton href={school.webTeamsPath}>Teams</NavButton>}
        {school.webScoresPath && <NavButton href={school.webScoresPath}>Scores</NavButton>}
        {school.webNewsPath && <NavButton href={school.webNewsPath}>News</NavButton>}
        {school.webPhotosPath && <NavButton href={school.webPhotosPath}>Photos</NavButton>}
        {school.nfhsNetworkUrl && <NavButton href={school.nfhsNetworkUrl}>Watch</NavButton>}
        {school.gofanTicketingUrl && <NavButton href={school.gofanTicketingUrl}>Tickets</NavButton>}
      </NavBar>
      <AdminBar user={school.owner}>
        <TextLink href={`/admin/schools/${school.id}`} target="_blank">
          School Admin
        </TextLink>
      </AdminBar>
    </>
  );
}
